const contentContract = `
  <p>
    J’autorise <strong>TRIANGLE INTERIM SOLUTIONS RH</strong> (RCS Pontoise 354 088 544) et son groupe 
    (« TRIANGLE »), expressément et sans aucune contrepartie financière, à collecter et traiter mes données 
    personnelles, à savoir mon nom, prénom, adresse de domicile et adresse e-mail, ainsi que mon image, ma voix 
    et toute information me concernant contenue dans ma vidéo de présentation professionnelle (« CV vidéo »), 
    dans le cadre de ses activités de recrutement et aux fins de traitement par les services recrutement et 
    relations humaines de TRIANGLE de ma candidature pour la mission concernée.
  </p>
  <p>
    Cette autorisation comprend, pendant une durée de 2 ans à compter de ce jour et sur l’ensemble du territoire français :
  </p>

  <ul>
    <li>La conservation, le stockage et l’archivage du CV vidéo ;</li>
    <li>Le traitement et l’utilisation du CV vidéo et de toute information qui y est communiquée, à des fins de sélection et d’évaluation de ma candidature ;</li>
    <li>La reproduction et la diffusion de tout ou partie du CV vidéo, sur tous supports, auprès des clients ou partenaires de TRIANGLE dans le cadre d’opportunités professionnelles correspondant à mon profil dans le cadre de missions ou de placements ;</li>
    <li>L’utilisation de mes données issues du CV vidéo à des fins statistiques, ainsi que pour toute opération de communication ou tout évènement promotionnel de TRIANGLE impliquant la mission concernée ;</li>
    <li>L’utilisation de mes données personnelles conformément au Règlement Général sur la Protection des Données (RGPD), notamment en garantissant leur sécurité, leur confidentialité et leur non-utilisation à des fins autres que celles mentionnées ci-dessus.</li>
  </ul>

  <p>
    Je reconnais avoir été informé(e) de mon droit d’accès, de rectification, d’effacement, d’opposition, de 
    limitation du traitement et de portabilité de mes données, en contactant : 
    <strong>TRIANGLE INTERIM SOLUTIONS RH</strong>, A l’attention du Data Protection Officer (DPO), 
    11 avenue de l’Ados, 95800 Cergy.
  </p>

  <p>
    Cette autorisation est valable pour une durée de 2 ans à compter de ce jour, sauf modification de mes données personnelles.
  </p>
`;

export default contentContract;
